import React, { useEffect, useState } from "react";
import { Box, IconButton, Stack, TextField } from "@mui/material";

import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { GradientBorderBox } from "../../../../Components";

export default function BlogSearchBar({ onSearch, search }) {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        mb: { xs: 5, md: 7 },
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 700,
          height: { xs: 58, md: 64 },
          display: "flex",
          position: "relative",
          alignItems: "center",
          // bgcolor: "#fff",
          // border: "2px solid rgba(247, 182, 69, 0.54)",
          transition: ".3s",
          // borderColor: "red",
          "&:hover": {
            borderColor: "primary.dark",
          },
          borderRadius: 2,

          "&:focus-within": {
            borderColor: "primary.main",
            boxShadow: "0 12px 35px rgba(10,25,49,.08)",
          },
        }}
      >
        <TextField
          fullWidth
          value={search}
          onChange={(e) => onSearch(e.target.value?.trim())}
          variant="standard"
          placeholder="دنبال چه مقاله‌ای می‌گردید؟"
          InputProps={{
            disableUnderline: true,
          }}
          sx={{
            px: 3,

            "& input": {
              textAlign: "right",
              color: "text.secondary",
              fontSize: "1rem",
            },

            "& input::placeholder": {
              color: "text.secondary",
              opacity: 1,
            },
          }}
        />
        <Stack
          sx={{
            width: { xs: 60, md: 72 },
            height: "100%",
            borderRadius: 0,
            color: "primary.main",
            transition: ".3s",
            justifyContent: "center",
            alignItems: "center",
            // "&:hover": {
            //   bgcolor: "primary.main",
            //   color: "#fff",
            // },
          }}
        >
          <SearchRoundedIcon sx={{ fontSize: 28 }} />
        </Stack>
        <GradientBorderBox
          inside
          bg={false}
          radius="12px"
          bgGrad="linear-gradient(
                       135deg,
                       #d1b31f90 -30%,
                       #31313130 50%,
                        rgb(157, 157, 157)  150%
                     )"
        />
      </Box>
    </Box>
  );
}
